import React from "react";
import DataIngestion from "../components/DataIngestion.tsx";
import { Search as SearchIcon } from "lucide-react";

const Search: React.FC = () => {
  return (
   <>
    <div className="flex items-center gap-3 mb-6 bg-white p-4 border-b border-gray-200">
     
        <h1 className="text-[20px] font-bold">Product Search</h1>
      </div>
    <div className="p-8">
     
      <DataIngestion />
    </div>
   </>
  );
};

export default Search;
